<template>
    <!-- Modal Update Remove -->
    <b-modal
        id="modal-add-paypal-ba"
        :title="title()"
        @shown="modalDidShow"
        centered
        hide-footer
        lazy
        ref="modalPaypalBA"
    >
        <div class="row">
            <div class="col">
                <div class="row" v-if="!baStarted">
                    <div class="col text-center">
                        <p>Set up a Billing Agreement with PayPal and link your PayPal account to Servers Australia.</p>
                        <form
                            class="mt-2"
                            id="myPaypalContainer"
                            method="post"
                            action="/billing/paypal-ba/start"
                        >
                            <input type="hidden" name="returnurl" :value="formpath">
                        </form>
                    </div>
                </div>
                <div class="form-row" v-else>
                    <div class="col">
                        <p
                            class="text-center"
                        >We're having an issue right now. Please call us on 1300 788 862.</p>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
//import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
export default {
    props: ["baStarted"],
    data() {
        return {
            formpath: null,
            ppScript: "https://www.paypalobjects.com/api/checkout.js",
        };
    },
    mounted() {
        const scripts = Array.from(document.getElementsByTagName("script")); // Check to see if paypal script is already active on the page

        if (!scripts.filter(script => script.src === this.ppScript).length) {
            let paypalScript = document.createElement("script");
            paypalScript.setAttribute("src", this.ppScript);
            document.head.appendChild(paypalScript);
        }
    },
    methods: {
        hideModal() {
            this.$refs.modalPaypalBA.hide();
        },
        title() {
            return "Link PayPal to your account";
        },
        modalDidShow() {
            this.formpath = window.location.pathname;
            paypal.checkout.setup(this.environment.paypal.merchant_id, {
                environment: this.environment.paypal.mode,
                buttons: [
                    {
                        container: "myPaypalContainer",
                        type: "login"
                    }
                ]
            });
        }
    }
};
</script>
